import React, { useEffect, useState } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';

import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import {
      CardHeader,
      CardLinks,
      CardTitle
} from '../../styles/components/common/Table';
import { LinkButton } from '../../styles/components/common/Button';
import FormInput from '../../components/form/FormInput';
import FormDescription from '../../components/form/FormDescription';
import FormStatusSelect from '../../components/form/FormStatusSelect';
import FormImage from '../../components/form/FormImage';
import MultipleImage from '../../components/form/MultipleImage';
import FormButton from '../../components/form/FormButton';
import FormSeo from '../../components/common/FormSeo';

const ProjectEdit = () => {
      const { projectId } = useParams();
      const navigate = useNavigate();
      const [loadingData, setLoadingData] = useState(false);

      const [loading, setLoading] = useState(false);
      const [image, setImage] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [location, setLocation] = useState('');
      const [website, setWebsite] = useState('');
      const [title, setTitle] = useState('');
      const [slug, setSlug] = useState('');
      const [description, setDescription] = useState('');
      const [date, setDate] = useState('');
      const [seoTitle, setSeoTitle] = useState('');
      const [seoKeyword, setSeoKeyword] = useState('');
      const [seoDescription, setSeoDescription] = useState('');
      const [images, setImages] = useState([]);
      const [imageFiles, setImageFiles] = useState([]);
      const [productImages, setProductImages] = useState([]);
      const [status, setStatus] = useState('');

      const token = JSON.parse(localStorage.getItem('token'));

      const loadData = async () => {
            setLoadingData(true);

            await axios
                  .get(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/projects/${projectId}`,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              setTitle(response.data.project.title);
                              setSlug(response.data.project.slug);
                              setWebsite(response.data.project.website);
                              setLocation(response.data.project.location);
                              setProductImages(response.data.project.images);
                              setImageUrl(response.data.project.image);
                              setSeoTitle(response.data.project.seo_title);
                              setSeoKeyword(response.data.project.seo_keyword);
                              setDescription(response.data.project.description);
                              setDate(response.data.project.date_edit);
                              setSeoDescription(
                                    response.data.project.seo_description
                              );
                              setStatus(response.data.project.status);
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoadingData(false);
      };

      useEffect(() => {
            loadData();
      }, []);

      const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            let updatedSlug = false;

            const handleUpdateSlug = () => {
                  if (updatedSlug) {
                        navigate(`/dashboard/projects/${updatedSlug}/edit`);
                  }
            };

            const data = {
                  title: title,
                  slug: slug,
                  location: location,
                  website: website,
                  status: status,
                  description: description,
                  date: date,
                  image: image,
                  images: imageFiles,
                  seo_title: seoTitle,
                  seo_description: seoDescription,
                  seo_keyword: seoKeyword
            };

            await axios
                  .post(
                        `${process.env.REACT_APP_SECRET_KEY}/api/dashboard/projects/${projectId}`,
                        data,
                        {
                              headers: {
                                    Authorization: `Bearer ${token}`,
                                    'Content-Type': 'multipart/form-data'
                              }
                        }
                  )
                  .then((response) => {
                        if (response.data.result === 'success') {
                              toast.success(response.data.message);
                              updatedSlug = slug;
                              handleUpdateSlug();
                        }
                        if (response.data.result === 'error') {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.slug) {
                                    toast.error(response.data.message.slug);
                              }
                              if (response.data.message.location) {
                                    toast.error(response.data.message.location);
                              }
                              if (response.data.message.website) {
                                    toast.error(response.data.message.website);
                              }
                              if (response.data.message.date) {
                                    toast.error(response.data.message.date);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                              if (response.data.message.description) {
                                    toast.error(
                                          response.data.message.description
                                    );
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.seo_title) {
                                    toast.error(
                                          response.data.message.seo_title
                                    );
                              }
                              if (response.data.message.seo_keyword) {
                                    toast.error(
                                          response.data.message.seo_keyword
                                    );
                              }
                              if (response.data.message.seo_description) {
                                    toast.error(
                                          response.data.message.seo_description
                                    );
                              }
                              if (response.data.message.seo_image) {
                                    toast.error(
                                          response.data.message.seo_image
                                    );
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader>
                                                <CardTitle>
                                                      Edit Project
                                                </CardTitle>
                                                <CardLinks>
                                                      <LinkButton to="/dashboard/projects">
                                                            Back
                                                      </LinkButton>
                                                </CardLinks>
                                          </CardHeader>

                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Project Title"
                                                            classes={7}
                                                            value={title}
                                                            required={true}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Slug"
                                                            classes={5}
                                                            value={slug}
                                                            required={true}
                                                            handleChange={
                                                                  setSlug
                                                            }
                                                      />

                                                      <FormInput
                                                            title="Location"
                                                            classes={4}
                                                            value={location}
                                                            handleChange={
                                                                  setLocation
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Website"
                                                            classes={4}
                                                            value={website}
                                                            handleChange={
                                                                  setWebsite
                                                            }
                                                      />
                                                      <FormInput
                                                            title="Project Date"
                                                            classes={4}
                                                            value={date}
                                                            type="date"
                                                            handleChange={
                                                                  setDate
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            selected={status}
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <FormDescription
                                                      title="Description"
                                                      required={true}
                                                      description={description}
                                                      setDescription={
                                                            setDescription
                                                      }
                                                />
                                          </Card.Body>
                                    </Card>
                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                      <MultipleImage
                                                            title="Other Images (Upload multiple images)"
                                                            images={images}
                                                            websiteImages={
                                                                  productImages
                                                            }
                                                            type="projects/images"
                                                            setProductImages={
                                                                  setProductImages
                                                            }
                                                            grid={4}
                                                            classes={8}
                                                            setImages={
                                                                  setImages
                                                            }
                                                            setImageFiles={
                                                                  setImageFiles
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>
                                    <FormSeo
                                          setSeoDescription={setSeoDescription}
                                          setSeoTitle={setSeoTitle}
                                          setSeoKeyword={setSeoKeyword}
                                          description={seoDescription}
                                          keyword={seoKeyword}
                                          title={seoTitle}
                                    />
                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Row>
                                                      <Col lg={12}>
                                                            <FormButton
                                                                  title="Submit"
                                                                  loading={
                                                                        loading
                                                                  }
                                                            />
                                                      </Col>
                                                </Row>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default ProjectEdit;
